import getAdjustedIconClassName from 'owa-mini-icons/lib/utils/getAdjustedIconClassName';
import React from 'react';
import { Button } from 'mini-button';
import { generateColorScheme } from 'mini-color-utils/lib/colorUtils';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';
import { MiniIcons } from 'owa-mini-icons';
import { RsvpAction } from '../schema/RsvpAction';
import {
    ACCEPTED_COLOR,
    CONFLICT_COLOR,
    TENTATIVE_COLOR,
} from 'mini-sass-mixins/lib/js/colorConstants';

const styles = require('./RsvpActionButtons.scss');
const classNames = require('classnames');

const getIconStyle = (iconName: string, customClassName?) =>
    classNames(getAdjustedIconClassName(iconName), customClassName);

const iconForYesAction = () => getIconStyle(MiniIcons.Accept, styles.actionIcon);
const iconForMayBeAction = () => getIconStyle(MiniIcons.Help, styles.maybeActionIcon);
const iconForNoAction = () => getIconStyle(MiniIcons.Cancel, styles.actionIcon);

export interface RsvpActionButtonProps {
    onAction: (ev?: React.MouseEvent<HTMLButtonElement>) => void;
    title?: string;
    titleAriaLabel?: string;
}

const getDefaultRsvpActionButtonProps = (
    actionType: RsvpAction,
    onAction: () => void
): RsvpActionButtonProps => {
    const strings = getOwaMiniCommonStrings();

    let title;
    let titleAriaLabel;

    switch (actionType) {
        case RsvpAction.YES:
            title = strings.rsvpYes;
            titleAriaLabel = strings.rsvpYesAriaLabel;
            break;
        case RsvpAction.MAYBE:
            title = strings.rsvpMaybe;
            titleAriaLabel = strings.rsvpMaybeAriaLabel;
            break;
        case RsvpAction.NO:
            title = strings.rsvpNo;
            titleAriaLabel = strings.rsvpNoAriaLabel;
            break;
    }

    return {
        title,
        titleAriaLabel,
        onAction,
    };
};

const getActionComponent = (
    props: RsvpActionButtonProps,
    response: RsvpAction,
    colorPrimaryHash: string,
    icon: string
): JSX.Element => {
    const {
        title: titleDefault,
        titleAriaLabel: titleAriaLabelDefault,
        onAction: onActionDefault,
    } = getDefaultRsvpActionButtonProps(response, props.onAction);

    const {
        title = titleDefault,
        titleAriaLabel = titleAriaLabelDefault,
        onAction = onActionDefault,
    } = props;

    return (
        <Button
            text={title}
            className={styles.actionBtn}
            icon={icon}
            onClick={onAction}
            ariaLabel={titleAriaLabel || title}
            colorScheme={generateColorScheme(colorPrimaryHash)}
        />
    );
};

export const RsvpYesButton: React.FC<RsvpActionButtonProps> = props =>
    getActionComponent(props, RsvpAction.YES, ACCEPTED_COLOR, iconForYesAction());

export const RsvpMaybeButton: React.FC<RsvpActionButtonProps> = props =>
    getActionComponent(props, RsvpAction.MAYBE, TENTATIVE_COLOR, iconForMayBeAction());

export const RsvpNoButton: React.FC<RsvpActionButtonProps> = props =>
    getActionComponent(props, RsvpAction.NO, CONFLICT_COLOR, iconForNoAction());
